import { useQuery } from '@tanstack/react-query';
import { eventsService } from '../services/eventsService.service';
import { Event } from '../types/event';

export const useEvents = (location?: string) => {
  return useQuery<Event[]>({
    queryKey: ['events', location],
    queryFn: () => eventsService.getEvents(location)
  });
};
